export default __webpack_public_path__ + "static/media/cyd.5cb93033.jpg";